import classnames from "classnames";
import React, { ReactNode } from "react";
import styled from "styled-components";

import theme from "../../theme";
import Slider from "../Slider/Slider.component";

import useSettings from "./useSettings";

interface ISlider {
  hasCustomPaging: boolean;
}

const StyledSlider = styled(Slider)<ISlider>`
  &.product-carousel {
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;

    .product-item {
      h2 {
        padding: 0;
      }
    }

    .slick-track {
      display: flex;
      align-items: baseline;
    }

    .slick-list {
      width: calc(100% - 40px);
      margin: 0 auto;
    }

    .slick-slide {
      transition: opacity 0.4s ease-in-out;
      padding: 0 ${theme.margins.paddingMedium};

      &:not(.slick-active) {
        pointer-events: none;
        opacity: 0.3;

        article > *:not(.productImageWrapper),
        article .wishListButton {
          opacity: 0;
        }
      }
    }

    ul.slick-dots {
      display: ${({ hasCustomPaging }: ISlider): string =>
        hasCustomPaging ? "flex !important" : "none !important"};
      position: initial;
      width: 100%;
      padding: 0;
      margin: 0;
      margin-top: 20px;

      &:after {
        content: initial;
      }

      li {
        display: inline-flex;
        flex-grow: 1;
        height: 3px;
        margin: 0;
        padding: 5px 0;
        width: initial;
        box-sizing: initial;

        &:first-child {
          margin-left: ${theme.margins.marginBig};
        }

        &:last-child {
          margin-right: ${theme.margins.marginBig};
        }

        div {
          background-color: ${theme.colors.veryLightGrey};
        }

        &.slick-active > div {
          background-color: ${theme.colors.black};
        }
      }
    }
  }
`;

interface IProps {
  children: ReactNode | ReactNode[];
  productsCount: number;
  className?: string;
  dots?: boolean;
  hasCustomPaging?: boolean;
  maxSlides?: string;
}

const ProductCarousel = ({
  children,
  productsCount,
  className,
  dots,
  hasCustomPaging = true,
  maxSlides,
}: IProps): JSX.Element => {
  const settings = useSettings(productsCount, maxSlides);

  return (
    <StyledSlider
      className={classnames(className, "product-carousel")}
      hasCustomPaging={hasCustomPaging}
      {...settings}
      dots={dots}
    >
      {children}
    </StyledSlider>
  );
};

export default ProductCarousel;
